// collaboration domain (Agenda + pin board) — D1-backed, migrated off the desktop's
// shared JSON file.
export const ENTRY_COLORS = ['#1c93a4', '#2e7d52', '#b8321f', '#cdd4d8', '#6b3fa0', '#d97706'];
//# sourceMappingURL=collab.js.map